import React, { useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import { withUserProfile } from '@withUserProfile';
import WithModal from "../../../../modules/Dispatch/RouteExecution/Pickups/PickupManagement/components/WithModal";
import styles from "../../../../modules/IBPlanning/Common/ModalStyle";
import { ImagesPopupProps } from '../types';
import { useIframeUrl } from './hooks/useIframeUrl';
import { useSectionSelection } from './hooks/useSectionSelection';
import { useImageMetadata } from './hooks/useImageMetadata';
import { popupStyles } from './styles/popupStyles';
import LeftSection from './components/LeftSection';
import RightSection from './components/RightSection';

const ImagesPopup: React.FC<ImagesPopupProps & { classes: any }> = (props) => {
  const { 
    imageGroups = [], 
    loading, 
    error, 
    onRetry,
    onLoadProImages,
    onFetchOnMount,
    configJSON,
    proNumber,
    userData,
    classes = {} as any
  } = props;

  // Fetch when dialog has mounted and when proNumber changes (refetch for new PRO)
  useEffect(() => {
    onFetchOnMount?.();
  }, [onFetchOnMount, proNumber]);

  const terminalOffset = userData?.userProfile?.terminal?.offset;

  const { iframeUrl, showCarrierImages } = useIframeUrl(proNumber, configJSON);
  const { selectedKey, handleSectionSelect } = useSectionSelection(
    showCarrierImages,
    imageGroups,
    proNumber
  );

  const allImages = React.useMemo(() => {
    return imageGroups.flatMap(group => group.images);
  }, [imageGroups]);

  const { imageURLDetailsByTimestamp } = useImageMetadata(
    allImages,
    loading || false,
    terminalOffset,
    proNumber
  );

  return (
    <div className={classes.dialogContent}>
      <LeftSection
        proNumber={proNumber}
        imageGroups={imageGroups}
        selectedKey={selectedKey}
        onSelect={handleSectionSelect}
        hasIframe={showCarrierImages}
        onLoadProImages={onLoadProImages}
        loading={loading}
        error={error}
        classes={classes}
      />

      <RightSection
        selectedKey={selectedKey}
        iframeUrl={iframeUrl}
        loading={loading}
        error={error}
        onRetry={onRetry}
        imageGroups={imageGroups}
        imageURLDetailsByTimestamp={imageURLDetailsByTimestamp}
        classes={classes}
      />
    </div>
  );
};

const combinedStyles = (theme: any) => ({
  ...styles(theme),
  ...popupStyles(theme),
});

const StyledComponent = withStyles(combinedStyles as any)(ImagesPopup);
export default compose(withUserProfile, WithModal)(StyledComponent) as React.ComponentType<any>;
